export default __webpack_public_path__ + "static/media/Boots of Lunacy.2f8e2eba.jpg";